// extracted by mini-css-extract-plugin
export default {"loaderContainer":"jvAUUC","loaderTitle":"ZgOmno","progressContainer":"s7j7TY","percentageText":"EWjxJl","phaseText":"jcsjmZ"};